import { useContext } from 'react';
import DisabledContext from '../DisabledContext';
import SizeContext from '../SizeContext';
function useConfig() {
  const componentDisabled = useContext(DisabledContext);
  const componentSize = useContext(SizeContext);
  return {
    componentDisabled,
    componentSize
  };
}
export default useConfig;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/config-provider/hooks/useConfig.js
// module id = 1471
// module chunks = 0